import { useEffect } from 'react';

import { useStore, accountsActions } from '@modules';
import { AccountsLimitsParams } from '@modules/accounts/types';

import useInterval from './useInterval';

const useUpdateAccountsLimits = (params: AccountsLimitsParams): void => {
  const { from, to } = params;
  const [{ accounts }, dispatch] = useStore();
  const isLoading =
    !!accounts.loaders.getAccountLimits || !!accounts.loaders.getAccountLimitsPolling;

  useEffect(() => {
    if (from && to) dispatch(accountsActions.getAccountLimits(params));
  }, [from, to]);

  useInterval({
    callback: () => dispatch(accountsActions.getAccountLimitsPolling(params)),
    delay: CONST.getLimitsInterval,
    shouldStop: isLoading,
  });
};

export default useUpdateAccountsLimits;
